import Vue from 'vue';
import Router from 'vue-router';

// pages
import About from './views/about.vue';
import Careers from './views/careers.vue';
import Contact from './views/contact.vue';
import Home from './views/home.vue';
import People from './views/people.vue';
import Bio from './views/bio.vue';
import Disclaimer from './views/disclaimer.vue';
import Terms from './views/terms.vue';

// router
Vue.use(Router);

export default new Router({
  mode: 'history',
  linkActiveClass: '',
  linkExactActiveClass: 'is-active',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/about',
      component: About,
    },
    {
      path: '/careers',
      component: Careers,
    },
    {
      path: '/contact',
      component: Contact,
    },
    {
      path: '/',
      component: Home,
    },
    {
      path: '/people',
      component: People,
      children: [
        {
          path: ':id',
          component: Bio,
          name: 'bio',
        },
      ],
    },
    {
      path: '/disclaimer/:id',
      component: Disclaimer,
    },
    {
      path: '/terms/:id',
      component: Terms,
    },
  ],
});
